export default __webpack_public_path__ + "static/media/MacRA-Design_LOGO-Design_on-transp.b20d1b19.png";